import { ReceiptStatus, TaxReceiptType } from '@/entities/user/@x/contract'

import { TContractReceiptInformation } from '../../model/schema'

export const 신청_안_함: TContractReceiptInformation = {
  receiptRequested: false,
  taxReceiptType: null,
  status: ReceiptStatus.PENDING,
  failedReason: null,
  billUrl: null,
  issuanceNumber: '',
  corpId: null,
  corpName: '',
  corpCeo: '',
  invoiceeEmail: '',
  isEditAvailable: true,
}

export const 신청: TContractReceiptInformation = {
  receiptRequested: true,
  taxReceiptType: TaxReceiptType.CASH_RECEIPT_BUSINESS,
  status: ReceiptStatus.PENDING,
  failedReason: null,
  billUrl: null,
  issuanceNumber: '0100001234',
  corpId: null,
  corpName: '',
  corpCeo: '',
  invoiceeEmail: '',
  isEditAvailable: true,
}

export const 정보_없음 = {
  receiptRequested: null,
  taxReceiptType: null,
  status: ReceiptStatus.PENDING,
  failedReason: null,
  billUrl: null,
  issuanceNumber: '',
  corpId: null,
  corpName: '',
  corpCeo: '',
  invoiceeEmail: '',
  isEditAvailable: true,
}
